module.exports = __webpack_public_path__ + "static/20-505cd4abfba3413b9fa06b76aa3e50b5.png";